export const preferenceSelector = state =>
  state.getIn(['app', 'appraisal', 'global', 'preference']);
export const selectedYearSelector = state =>
  state.getIn(['app', 'appraisal', 'global', 'selectedYear']);
export const viewOnlySelector = state =>
  state.getIn(['app', 'appraisal', 'global', 'viewOnly']);
export const selectedOwnerRecordSelector = state =>
  state.getIn(['app', 'appraisal', 'global', 'selectedOwnerRecord']);
export const selectedAgentRecordSelector = state =>
  state.getIn(['app', 'appraisal', 'global', 'selectedAgentRecord']);
export const quickSearchFlagSelector = state =>
  state.getIn(['app', 'appraisal', 'global', 'quickSearchFlag']);
export const selectedBuilderPlanSelector = state =>
  state.getIn(['app', 'appraisal', 'global', 'selectedBuilderPlanRecord']);
export const selectedMortgagelenderRecordSelector = state =>
  state.getIn(['app', 'appraisal', 'global', 'selectedMortgagelenderRecord']);
export const selectedWebpageRecordSelector = state =>
  state.getIn(['app', 'appraisal', 'global', 'selectedWebpageRecord']);
export const selectedDeedRecordSelector = state =>
  state.getIn(['app', 'appraisal', 'global', 'selectedDeedRecord']);
export const selectedPropertyRecordSelector = state =>
  state.getIn(['app', 'appraisal', 'global', 'selectedPropertyRecord']);
export const selectedPropertyRecordYearSelector = state =>
  state.getIn(['app', 'appraisal', 'global', 'selectedPropertyRecordYear']);
export const selectedPropertyPVersionSelector = state =>
  state.getIn(['app', 'appraisal', 'global', 'selectedPropertyPVersion']);
export const selectedPropertyPRollCorrSelector = state =>
  state.getIn(['app', 'appraisal', 'global', 'selectedPropertyPRollCorr']);
export const selectedSmartGroupSelector = state =>
  state.getIn(['app', 'appraisal', 'global', 'selectedSmartGroupRecord']);
export const selectedEconomicUnitSelector = state =>
  state.getIn(['app', 'appraisal', 'global', 'selectedEconomicUnitRecord']);
export const selectedEconomicUnitYearSelector = state =>
  state.getIn(['app', 'appraisal', 'global', 'selectedEconomicUnitYear']);
export const selectedEconomicUnitVersionSelector = state =>
  state.getIn(['app', 'appraisal', 'global', 'selectedEconomicUnitVersion']);
export const selectedEconomicUnitRollCorrSelector = state =>
  state.getIn(['app', 'appraisal', 'global', 'selectedEconomicUnitRollCorr']);
export const isMenuVisibleSelector = state =>
  state.getIn(['app', 'appraisal', 'global', 'isMenuVisible']);
export const propertyTypesSelector = state =>
  state.getIn(['app', 'appraisal', 'global', 'propertyTypes']);
export const rolesSelector = state =>
  state.getIn(['app', 'appraisal', 'global', 'roles']);
export const sideMenuSelector = state =>
  state.getIn(['app', 'appraisal', 'global', 'sideMenu']);
export const currentAppraisalYearSelector = state =>
  state.getIn(['app', 'appraisal', 'global', 'currentAppraisalYear']);
export const appraisalYearsSelector = state =>
  state.getIn(['app', 'appraisal', 'global', 'years']);
export const appraisalYearsDataSelector = state =>
  state.getIn(['app', 'appraisal', 'global', 'years', 'data']).toJS();
export const appraisersSelector = state =>
  state.getIn(['app', 'appraisal', 'global', 'appraisers']);
export const appraisalCompaniesSelector = state =>
  state.getIn(['app', 'appraisal', 'global', 'appraisalCompanies']);
export const assignmentPathSelector = state =>
  state.getIn(['app', 'appraisal', 'global', 'assignmentPath']).toJS();
export const econNavDataSelector = state =>
  state.getIn(['app', 'appraisal', 'global', 'econNavData']).toJS();
